module.exports = ".texto-grande {\n  height: 200px;\n  overflow-y: scroll; }\n\n@media (min-width: 768px) {\n  .modal-dialog-centered {\n    margin: 25vh auto !important; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/proposta/historicoEmail/historico-email.component.scss
// module id = ./src/app/components/proposta/historicoEmail/historico-email.component.scss
// module chunks = main